import type { EstimateFormErrors, EstimateFormValues } from '../types/estimate';

export function validateEstimate(values: EstimateFormValues): EstimateFormErrors {
  const errors: EstimateFormErrors = {};

  if (!values.name.trim()) errors.name = 'Please enter your name.';

  const digits = values.phone.replace(/\D/g, '');
  if (!digits) errors.phone = 'We need a phone number to reach you.';
  else if (digits.length < 10) errors.phone = 'Enter a 10-digit phone number.';

  if (values.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) {
    errors.email = 'Enter a valid email address.';
  }

  if (!values.vehicle.trim()) errors.vehicle = 'Tell us the year, make, and model.';
  if (!values.description.trim()) errors.description = 'Briefly describe the damage.';

  return errors;
}

export async function sendEstimateRequest(values: EstimateFormValues, photos: File[]): Promise<void> {
  // Simulated network request — replace with a real endpoint.
  await new Promise((resolve) => setTimeout(resolve, 1200));
  if (!values.name || photos.length > 10) {
    throw new Error('Request failed');
  }
}
